function queryStringParser(search) {
  const params = new URLSearchParams(search);
  return params;
}

export default queryStringParser;
